import { put, select, takeLatest } from 'redux-saga/effects';
import {
    partsSelectActions,
    setPartsSelectAction,
    priceSumAction,
    fetchInitProductSetItemAction,
} from '@app/react/action';
import { fetchCartItemAction } from '@app/react/action/fetchCartItem';
import type { AppState } from '@app/react/reducer';

type H = (state: AppState) => number;

const selectUnitPrice = (state: AppState): number =>
    state.customize.unit?.price ?? 0;

const selectUnit = (state: AppState): number =>
    state.customize.unit?.options?.unit ?? 0;

function* calcPrice() {
    const sumArray: number[] = [];

    const unitPrice: number = yield select(selectUnitPrice);
    const unitNumber: number = yield select(selectUnit);

    sumArray.push(yield select<H>((state) => state.customize.shaft?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.feather?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.thread?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.kebiki?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.nock?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.arrowhead?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.arrowlength?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.arrowinsert?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.twine?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.lame?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.carving?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.familycrest?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.typezero?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.decoration?.price ?? 0));
    sumArray.push(yield select<H>((state) => state.customize.featherinside?.price ?? 0));
    sumArray.push(unitPrice);

    const price = sumArray.reduce((acc, eachPrice) => acc + (eachPrice * unitNumber), 0);
    yield put(priceSumAction({ price }));
}

export const priceSumSaga = [
    takeLatest(partsSelectActions.shaft.started.type, calcPrice),
    takeLatest(partsSelectActions.feather.started.type, calcPrice),
    takeLatest(partsSelectActions.thread.started.type, calcPrice),
    takeLatest(partsSelectActions.kebiki.started.type, calcPrice),
    takeLatest(partsSelectActions.nock.started.type, calcPrice),
    takeLatest(partsSelectActions.arrowhead.started.type, calcPrice),
    takeLatest(partsSelectActions.arrowlength.started.type, calcPrice),
    takeLatest(partsSelectActions.unit.started.type, calcPrice),
    takeLatest(partsSelectActions.arrowinsert.started.type, calcPrice),
    takeLatest(partsSelectActions.twine.started.type, calcPrice),
    takeLatest(partsSelectActions.lame.started.type, calcPrice),
    takeLatest(partsSelectActions.carving.started.type, calcPrice),
    takeLatest(partsSelectActions.familycrest.started.type, calcPrice),
    takeLatest(partsSelectActions.typezero.started.type, calcPrice),
    takeLatest(partsSelectActions.decoration.started.type, calcPrice),
    takeLatest(partsSelectActions.featherinside.started.type, calcPrice),
    takeLatest(setPartsSelectAction.done.type, calcPrice),
    takeLatest(fetchCartItemAction.done.type, calcPrice),
    takeLatest(fetchInitProductSetItemAction.done.type, calcPrice),
];
